<img [src]="linkToSvg$ | async" [width]="width" [height]="height" class="qr-code" alt="qrCode">